/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Col_AmountInputs */

const vi_reconcile_col_amount = /** @type {(inputs: Reconcile_Col_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền`)
};

/**

* @param {Reconcile_Col_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_col_amount = /** @type {((inputs?: Reconcile_Col_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Col_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_col_amount(inputs)
});